import { LineChart, Vars } from '@carrent/ui'
import { RUB } from './format'

/** Гаджет: Финансы парка: динамика расходов и структура. */

export function FinanceWidget({ data }) {
  if (!data.daily.length) {
    return <p className="widget-empty">За период расходов не было</p>
  }

  const max = Math.max(...data.categories.map((c) => c.value), 1)

  return (
    <div className="finance">
      <div className="finance__totals">
        <span className="finance__total">{RUB.format(data.total)} ₽</span>
        {data.cost_per_km != null && (
          <span className="finance__rate">{data.cost_per_km} ₽/км</span>
        )}
        <span className="text-muted">за {data.period_days ?? '—'} дн.</span>
      </div>

      <LineChart
        data={data.daily}
        valueKey="expenses"
        color="var(--secondary)"
        label="Расходы по дням"
        formatValue={(v) => `${RUB.format(v)} ₽`}
      />

      <ul className="finance__cats">
        {data.categories.map((c) => (
          <li key={c.key} className="finance__cat">
            <span className="finance__cat-label">{c.label}</span>
            <span className="finance__cat-track">
              <Vars
                as="span"
                className="finance__cat-bar"
                vars={{ '--bar-w': `${(c.value / max) * 100}%` }}
              />
            </span>
            <span className="finance__cat-value">{RUB.format(c.value)} ₽</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
